import { api } from "../../../api/api";
import { getFileExtensionFromUrl, getFileNameFromUrl } from "./getFileNameFromUrl";

export const downLoadFile = async (fileName?: string | null) => {
    if (fileName) {
      const res = await api.get(
        "/user/download-file",
        {
          params: { fileKey: fileName },
          responseType: "blob", 
        },
      );
      console.log(res);

      const blob = res.data instanceof Blob 
        ? res.data 
        : new Blob([res.data], { type: res.headers?.["content-type"] || ('application/' + getFileExtensionFromUrl(fileName)) });

      const url = window.URL.createObjectURL(blob);
  
      // Create a link element and simulate a click to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", getFileNameFromUrl(fileName)); // Set the desired file name and extension
      document.body.appendChild(link);
      link.click();
  
      // Clean up by revoking the URL object
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    }
    return null;
  };
  